export default __webpack_public_path__ + "static/media/mainpage_photo.d82bd1b8.svg";